import { render, staticRenderFns } from "./DanaIframe.vue?vue&type=template&id=27fcbc37&scoped=true&"
import script from "./DanaIframe.vue?vue&type=script&lang=js&"
export * from "./DanaIframe.vue?vue&type=script&lang=js&"
import style0 from "./DanaIframe.vue?vue&type=style&index=0&id=27fcbc37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcbc37",
  null
  
)

component.options.__file = "DanaIframe.vue"
export default component.exports